import React from "react";
import { useMedia } from "../ResponsiveMedia";
import transformPadding from "./transformPadding";

const Container = ({
  backgroundColor = null,
  children = null,
  className = null,
  maxWidth = "1370px",
  padding = { xs: 2, md: 3, lg: 4, xl: 4, xxl: 4 }
}) => {
  const style = {
    backgroundColor,
    boxSizing: "border-box",
    padding: useMedia(padding, transformPadding)
  };

  if (window.innerWidth >= 1900) {
    maxWidth = "1700px";
  }
  if (window.innerWidth >= 1500 && window.innerWidth < 1900) {
    maxWidth = "1500px";
  }

  if (window.innerWidth >= 1300 && window.innerWidth < 1500) {
    maxWidth = "1300px";
  }
  if (window.innerWidth >= 1200 && window.innerWidth <= 1300) {
    maxWidth = "1100px";
  }
  if (window.innerWidth < 1200) {
    maxWidth = "900px";
  }
  return (
    <div className={className} style={style}>
      <div style={{ margin: "0 auto ", maxWidth }}>{children}</div>
    </div>
  );
};

export default Container;
